/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import routes from '../../common/constants/RouteConstants';
import { ssoLogIn, resetErrorMessage, setUsername } from '../../store/routines';
import InputValidationMessage from '../../components/InputMessageContainers/InputValidationMessage';
import { formatUserName } from '../../common/util/EmailUtils';
import { cognitoLoginErrorMessageFormatter } from '../../common/util/authUtils';

const feature = 'sso-login-form';

function SSOLoginForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();

  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const isError = useSelector((state) => state.auth.isLoginError);
  const [errorVisible, setErrorVisible] = useState(false);

  useEffect(() => {
    if (errorMessage) {
      setErrorVisible(true);
    }
  }, [errorMessage]);

  const onFormChange = (changedValues) => {
    if (changedValues) {
      setErrorVisible(false);
    }
  };

  const onSSOLoginFinish = (values) => {
    const { username } = values;
    const formattedUserName = formatUserName(username); // todo can we use the same method for login insted of inline trime
    dispatch(setUsername({ username: formattedUserName }));
    dispatch(ssoLogIn({ username: formattedUserName }));
  };

  useEffect(() => {
    return () => {
      dispatch(resetErrorMessage());
    };
  }, []);

  const handleBackToLogin = () => {
    history.push(routes.loginManagement.login);
  };

  return (
    <>
      <div className="login-input-wrapper">
        {/* <div className="title smaller">Forgot your password?</div> */}
        <div className="subtitle" />
        <Form
          form={form}
          name="login_step_1"
          className="login-form"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onSSOLoginFinish}
          onValuesChange={onFormChange}
        >
          {isError && errorVisible && (
            <div className="login-error-bar" data-testid={`${feature}-err`}>
              <i className="icon core-icon core-alert-outlined" />{' '}
              {cognitoLoginErrorMessageFormatter(errorMessage, true)}
            </div>
          )}

          <Form.Item
            name="username"
            label="Email Address"
            className="login-field"
            rules={[
              {
                required: true,
                message: (
                  <InputValidationMessage
                    data-testid={`${feature}-username`}
                    message="Please enter your email address"
                  />
                ),
              },
            ]}
          >
            <Input
              className="login-field"
              data-testid={`${feature}-username-txtin`}
              autoFocus
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button loginbtn"
              data-testid={`${feature}-submit-btn`}
            >
              Log In
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="floating-login-footer">
        <a
          className="request-new-pw"
          role="link"
          tabIndex="0"
          onClick={handleBackToLogin}
          data-testid={`${feature}-redirect-to-login-link`}
        >
          Login Using Username/Password
        </a>
      </div>
    </>
  );
}
export default SSOLoginForm;
